import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const LightLogo = () => {
  const { file } = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "ccLogoLight.png" }) {
        childImageSharp {
          fixed(width: 40, height: 40) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return <Img fixed={file.childImageSharp.fixed} />
}

export default LightLogo
